import React from "react";

const technologies = [
  {
    name: "Alchemy",
    url: "https://cdn.brandfetch.io/idpio7klyu/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1743500213415",
  },
  {
    name: "Coinbase",
    url: "https://logo.clearbit.com/coinbase.com",
  },
  {
    name: "MetaMask",
    url: "https://seeklogo.com/images/M/metamask-logo-09EDE53DBD-seeklogo.com.png",
  },
  {
    name: "Uniswap",
    url: "https://app.uniswap.org/static/media/uniswap-logo.9193bf7e07fdaeb1d87b.png",
  },
  {
    name: "The Graph",
    url: "https://upload.wikimedia.org/wikipedia/fr/2/27/The_graph_logo.png",
  },
  {
    name: "Base",
    url: "https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/base/info/logo.png",
  },
  {
    name: "Foundry",
    url: "https://www.useanvil.com/_next/static/images/16529f955c9d62765492ede4f63f2eee.svg",
  },
  {
    name: "Reown",
    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ5-pv3rSRhVny38dX-3EXfrfZHs8V8Lh7_yw&s",
  },
];

const SupportedTechnologies: React.FC = () => {
  return (
    <section className="bg-[#eeeeee]  px-6 py-5 max-w-xs mx-auto shadow-inner">
      <h5 className="text-[18px] sm:text-lg font-bold text-center text-[#032c58] mb-4">
        Powered by Web3 Infrastructure{" "}
      </h5>
      <div className="flex flex-wrap justify-center gap-x-4 gap-y-4">
        {technologies.map((tech) => (
          <div
            key={tech.name}
            className="flex flex-col items-center justify-center w-[70px]"
          >
            <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-white shadow flex items-center justify-center">
              <img
                src={tech.url}
                alt={tech.name}
                className="w-7 h-7 object-contain"
              />
            </div>
            <span className="text-[10px] sm:text-xs text-[#333] font-medium text-center mt-1">
              {tech.name}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SupportedTechnologies;
